import React, { useState } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import Api from "../../../../services/ServiceApi";
import moment from "moment";
import Cookies from "js-cookie";
import { StatusInfo } from "../../../utility/status_info_modal";
export default function SmsRequsetModal({
  CompanyId,
  OperatorId,
  ProjectId,
  modalOpen,
  setmodalOpen,
  language,
  factupdate,
  jobDetail,
  Jobdata,
  mode,
  wrapClassName,
}) {
  const { Option } = Select;
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  const [form] = Form.useForm();
  const [statusSave, setstatusSave] = useState(false);
  const { result_site_detail } = Jobdata;
  const siteCodeList = result_site_detail.map((s) => ({
    value: s.job_site_code,
    label: s.job_site_code,
  }));
  const [Spin, setSpin] = useState(true);
  const [loadingText, setloadingText] = useState("Loading");
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  const handleSubmit = (value) => {
    setstatusSave(true);
    setloadingText("Send Request SMS");
    if (mode === "onsite") {
      Api.post("job_detail/insert_sms_send_log", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_category_id: jobDetail?.job_category_id,
        job_id: jobDetail?.job_id,
        site_code: value.siteCode,
        sms_send_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
        sms_send_by: Cookies.get("username"),
        remark: value.remark,
        result: "Pending",
        sms_config_id: 1,
        sms_send_seq_id: 1,
        sms_seq: 1,
        sms_client_name: "UIH Operator",
        sms_protocal: "TEXT",
        sms_destination: "1600375",
        message_direction: "S",
        message_subject: "",
        message_body: "01,zxczxc,o,TRS,audit,EQUIPMENT",
        message_description: "SMS ขอเข้าพื้นที่",
      })
        .then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            setloadingText("Success");
            setSpin(false);
          } else {
            setloadingText(`Error : ${result.showText}`);
            setSpin(false);
            setstatusInfoMode("error");
          }
        })
        .catch((err) => {
          setloadingText(`Error : ${err}`);
          setSpin(false);
          setstatusInfoMode("error");
        });
    } else if (mode === "offsite") {
      Api.post("job_detail/insert_sms_send_log", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_category_id: jobDetail?.job_category_id,
        job_id: jobDetail?.job_id,
        site_code: value.siteCode,
        sms_send_datetime: moment().format("YYYY/MM/DD HH:mm:ss"),
        sms_send_by: Cookies.get("username"),
        remark: value.remark,
        result: "Pending",
        sms_config_id: 1,
        sms_send_seq_id: 1,
        sms_seq: 1,
        sms_client_name: "UIH Operator",
        sms_protocal: "TEXT",
        sms_destination: "1600375",
        message_direction: "S",
        message_subject: "",
        message_body: "01,zxczxc,o,TRS,audit,EQUIPMENT",
        message_description: "SMS ขอออกจากพื้นที่",
      })
        .then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            setloadingText("Success");
            setSpin(false);
          } else {
            setloadingText(`Error : ${result.showText}`);
            setSpin(false);
            setstatusInfoMode("error");
          }
        })
        .catch((err) => {
          setloadingText(`Error : ${err}`);
          setSpin(false);
          setstatusInfoMode("error");
        });
    }
  };
  const statusInfoCallBack = () => {
    setstatusSave(false);
    window.location.reload();
  };
  return (
    <>
      <Modal
        title={
          statusSave ? null : mode === "onsite" ? (
            <>
              <img
                src={Api.absoluteUrl(`/icon/bbtec/button/md/sms-on-site.svg`)}
                alt={"sms-on-site"}
              />
              <span className="font-thai-b fs-20 ml-1">{`SMS ขอเข้าพื้นที่`}</span>
            </>
          ) : (
            <>
              <img
                src={Api.absoluteUrl(`/icon/bbtec/button/md/sms-off-site.svg`)}
                alt={"sms-off-site"}
              />
              <span className="font-thai-b fs-20 ml-1">{`SMS ขอออกจากพื้นที่`}</span>
            </>
          )
        }
        footer={null}
        visible={modalOpen}
        onCancel={() => setmodalOpen(false)}
        wrapClassName={wrapClassName}
      >
        {statusSave ? (
          <StatusInfo
            callbackFunction={statusInfoCallBack}
            showSpinIcon={Spin}
            statusText={loadingText}
            mode={statusInfoMode}
          ></StatusInfo>
        ) : (
          <Form
            form={form}
            name="sms_request_to_site"
            {...formItemLayout}
            initialValues={{ siteCode: siteCodeList[0].value }}
            onFinish={handleSubmit}
          >
            <Form.Item name="siteCode" label="Site Code : ">
              <Select>
                {siteCodeList?.map((s, i) => (
                  <Option key={`Option_Sms_ReqSite_index_${i}`} value={s.value}>
                    {s.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="remark" label="Remark : ">
              <Input.TextArea rows="5"></Input.TextArea>
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button className="mr-3" onClick={() => setmodalOpen(false)}>
                Close
              </Button>
              <Button type="primary" htmlType="submit" disabled={statusSave}>
                Confirm
              </Button>
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
}
